import { useEventListener } from '@vueuse/core';
import { wrap, isClient } from './utils';

const events = ['mousedown', 'touchstart'];

/**
 * Outside Click Hook
 *
 * @param {ref|HTMLElement} el
 * @param {Function} onOutsidePressCallback
 */
export function useOutsideClick(el, onOutsidePressCallback) {
  if (!isClient) {
    return () => {};
  }
  const element = wrap(el);
  const handler = (e) => {
    // Eğer modal içinde bi yere tıklandııysa outside click fonksiyonunu çağırma.
    const activeModals = document.querySelectorAll('.o-modal');
    const targetIsInModal =
      activeModals &&
      [...activeModals].some((modal) => {
        return modal.contains(e.target);
      });

    if (targetIsInModal) {
      return;
    }
    // modal dışında ise çağır
    if (element.value && !element.value.contains(e.target)) {
      onOutsidePressCallback(e);
    }
  };
  const event = events.find((x) => `on${x}` in document.documentElement);

  return useEventListener(document, event, handler, { passive: true });
}
